import { useEffect, useState } from 'react';
import { useDataContext } from '../../../../../context';
import { useToast } from '../../../../../context/ToastContext';
import { Scopes } from '../../../../../services/endpoints/people/user';
import PowerBIReports from '../../../../../services/endpoints/powerBi/PowerBIReports';
import {
  PowerBi,
  useGetPowerBiTokensQuery
} from '../../../../../services/endpoints/powerBi/powerBiToken';
import { getCurrentUser } from '../../../../../services/helper';
import { GetQueryParams } from '../../../../../types/api.type';

const defaultScope = 'all';
const currentUser = getCurrentUser();

export const PowerBiView = () => {
  const { addToast } = useToast();
  const { locationOptions } = useDataContext();
  const [filters, setFilters] = useState<GetQueryParams>({
    scope: defaultScope,
    data: { page: 1, entries: 10 }
  });
  const [scopes, setScopes] = useState<Scopes>({});
  const [powerBiToken, setPowerBiToken] = useState<PowerBi[]>();
  const [accsessToken, setAccsessToken] = useState<string>();
  const [embedToken, setEmbedToken] = useState<string>();
  const [reportId, setReportId] = useState<string>();
  const [workspaceId, setWorkspaceId] = useState<string>();
  const isGlobalUser = currentUser?.isGlobal;
  const userCanSeeFinancials = currentUser?.canSeeFinancials;
  const { data, error, isLoading } = useGetPowerBiTokensQuery();

  useEffect(() => {
    if (data && data?.results) {
      const accessToken = Object.entries(data?.results)[0][1];
      const embedToken = Object.entries(data?.results)[1][1];
      const workspaceId = Object.entries(data?.results)[2][1];
      const reportId = Object.entries(data?.results)[3][1];
      setAccsessToken(accessToken);
      setEmbedToken(embedToken);
      setWorkspaceId(workspaceId);
      setReportId(reportId);

      setPowerBiToken(data?.results);
    }
  }, [data]);

  const setFilterBy = (filterBy: { operator: string; field: string; value: string }[]) => {
    setFilters((prev) => ({
      ...prev,
      data: {
        ...prev!.data,
        filterBy
      }
    }));
  };

  return (
    <div className="py-2">
      {accsessToken && embedToken && workspaceId && reportId && (
        <PowerBIReports
          accessToken={accsessToken}
          embedToken={embedToken}
          workspaceId={workspaceId}
          reportId={reportId}
        />
      )}
    </div>
  );
};
